import React from "react";
import PhoneIcon from "@mui/icons-material/Phone";
import { primary } from "../../constants/theme";

const PricingEvExpertsBanner = () => {
  return (
    <div className="w-full md:w-[84%] mx-auto px-3 md:px-0 py-6 md:py-8">
      <div
        className="w-full rounded-lg px-4 md:px-6 py-4 md:py-5 flex flex-col md:flex-row items-center md:items-center justify-between gap-4 md:gap-6"
        style={{ background: primary?.main }}
      >
        <h2 className="text-xl md:text-2xl font-bold text-white text-left">
          Talk to our EV Experts
        </h2>
        <a
          href="tel:08047482233"
          className="flex items-center gap-2 md:gap-3 text-white hover:opacity-95 transition-opacity"
        >
          <PhoneIcon className="text-white" style={{ fontSize: "24px" }} />
          <span className="text-lg md:text-xl font-bold">08047482233</span>
        </a>
      </div>
    </div>
  );
};

export default PricingEvExpertsBanner;
